import styled, { css } from 'styled-components'

// PDP Hack: Change "cross" to "out_of_stock" as Basket yet to migrate to Bolt2
const icons = {
  tick: 'url(//www.argos.co.uk/cdn/argos-style/1.1.8/assets/svg/in-stock.svg);',
  out_of_stock: 'url(//www.argos.co.uk/cdn/argos-style/1.1.8/assets/svg/sold-out.svg);',
  clock: 'url(//www.argos.co.uk/cdn/argos-style/1.1.8/assets/svg/clock.svg);',
  calendar: 'url(//www.argos.co.uk/cdn/argos-style/1.1.8/assets/svg/calendar.svg);'
}

const Container = styled.span`
  display: block;
  position: relative;
  padding-left: ${props => (props.hideIcon ? '0px' : '33px')};
  padding-right: ${props => (props.fastTrack ? '40px' : '0px')};
  margin-top: 10px;
  span {
    padding-right: 30px;
  }
  ${css`
    &::before {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      background-size: 20px 20px;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -10px;
      background-image: ${props => !props.hideIcon && icons[props.icon]};
    }
  `}
`

const Button = styled.button`
  position: absolute;
  top: 50%;
  margin-top: -8px;
  right: 0;
  width: 32px;
  height: 16px;
  background-color: transparent;
  background-image: url('//documents.4rgos.it/v1/static/fast-track');
  background-repeat: no-repeat;
  background-position: 0 0;
  outline: 0;
  border: 0;
  appearance: none;
`

export { Container, Button }
